import { Select } from "components/form";
import { TextField } from "components/form";
import { Field, FieldArray } from "formik";

const socials = [
  { label: "فیسبوک", value: "Facebook" },
  { label: "اینستاگرام", value: "Instagram" },
  { label: "توییتر", value: "Twitter" },
  { label: "لینکدین", value: "LinkedIn" },
  { label: "یوتیوب", value: "YouTube" },
];

export default function SocialComponent({ values, setFieldValue, type }) {
  return (
    <div className="w-full mt-20">
      <FieldArray name="socials">
        {({ push: addSocial, remove: removeSocial }) => (
          <div>
            <div className="flex items-center justify-between mb-6">
              <h4 className="font-bold text-lg mb-4">سوشیال مدیا</h4>
              <button
                type="button"
                onClick={() => {
                  addSocial({
                    userType: type,
                    user: values?.id,
                    platform: "",
                    url: "",
                  });
                }}
                className="mb-4 px-4 py-2 bg-green-500 text-white rounded shadow hover:bg-green-600"
              >
                افزودن سوشیال مدیا
              </button>
            </div>

            {values.socials?.map((social, idx) => (
              <div key={idx} className="mb-6 border p-4 rounded shadow">
                <div className="mb-4">
                  <Field
                    label="پلتفرم :"
                    name={`socials[${idx}]platform`}
                    component={Select}
                    options={socials}
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    placeholder="آدرس"
                    label="آدرس :"
                    name={`socials[${idx}]url`}
                    component={TextField}
                  />
                </div>

                <button
                  type="button"
                  onClick={() => {
                    setFieldValue("deleteSocials", [
                      ...(values?.deleteSocials || []),
                      values?.socials[idx]?.id,
                    ]);
                    removeSocial(idx);
                  }}
                  className="px-3 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600"
                >
                  حذف سوشیال مدیا
                </button>
              </div>
            ))}
          </div>
        )}
      </FieldArray>
    </div>
  );
}
